import {createContext} from "react";
import {IAccountFavoritesContext} from "../models/Account/IAccountFavoritesContext.ts";
import {IFavorite} from "../../interfaces/account/favorite/IFavorite.ts";
import { FavoriteTypeEnum } from '../../types/account/favoriteTypeTypes.ts';

export const AccountFavoritesContext = createContext<IAccountFavoritesContext>({
    favorites: [],
    getAll: function (): Promise<void> {
        throw new Error("Function not implemented.");
    },
    updateAll: function (favorites: IFavorite[]): void {
        favorites;
        throw new Error("Function not implemented.");
    },
    deleteFavorite: function (id: string): Promise<void> {
        id;
        throw new Error("Function not implemented.");
    },
    add: function (name: string, searchQuery: string, type: FavoriteTypeEnum): Promise<void> {
        name;
        searchQuery;
        type;
        throw new Error("Function not implemented.");
    },
    checkIfFavoriteExists(searchQuery: string, type: FavoriteTypeEnum): boolean {
        searchQuery;
        type;
        return false;
    }
});